module.exports = "images/get-inspired-3.webp";